import { PayoutStatus } from './infra/dtos';

const flagTranslations: Record<string, string> = {
  SameTrackingId: 'Self referral',
  SubsequentClaims: 'Same behavioral entity',
  SameCommunity: 'Same cluster',
};

export function translateFlag(flag: string): string {
  return flagTranslations[flag] || flag;
}

const STATUS_COLORS = {
  success: { backgroundColor: 'rgba(16, 185, 129, 0.08)', color: '#10b981' },
  warning: { backgroundColor: 'rgba(245, 158, 11, 0.08)', color: '#f59e0b' },
  error: { backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' },
};

export function usePayoutStatusColors() {
  return {
    [PayoutStatus.Confirmed]: STATUS_COLORS.success,
    [PayoutStatus.PendingApproval]: STATUS_COLORS.warning,
    [PayoutStatus.PendingConfirmation]: STATUS_COLORS.warning,
    [PayoutStatus.SendingTransaction]: STATUS_COLORS.warning,
    [PayoutStatus.PendingTransaction]: STATUS_COLORS.warning,
    [PayoutStatus.Deferred]: STATUS_COLORS.warning,
    [PayoutStatus.Failed]: STATUS_COLORS.error,
    [PayoutStatus.Rejected]: STATUS_COLORS.error,
  };
}
